import { Autocomplete, Chip, Stack, TextField } from '@mui/material'
import { EditorField } from './schemaEditorReducer'
import PaduConfig from './PaduConfig'

interface P {
    field: EditorField
    onUpdateField: (
        fieldId: string,
        updates: Partial<EditorField>
    ) => void
}

const StringFieldConfig = ({ field, onUpdateField }: P) => {
    return (
        <Stack spacing={2}>
            <Stack flex={1} direction='row' spacing={2}>
                <TextField
                    disabled={field.isDefault}
                    fullWidth
                    size='small'
                    label='Minimum Length'
                    type='number'
                    value={field.validation?.minLength ?? ''}
                    onChange={e => onUpdateField(field._id, {
                        validation: {
                            minLength: e.target.value === '' ? undefined : Number(e.target.value)
                        }
                    })}
                />
                <TextField
                    disabled={field.isDefault}
                    fullWidth
                    size='small'
                    label='Maximum Length'
                    type='number'
                    value={field.validation?.maxLength ?? ''}
                    onChange={e => onUpdateField(field._id, {
                        validation: {
                            maxLength: e.target.value === '' ? undefined : Number(e.target.value)
                        }
                    })}
                />
            </Stack>
            <Stack>
                <TextField
                    disabled={field.isDefault}
                    fullWidth
                    size='small'
                    label='Pattern (RegEx)'
                    value={field.validation?.pattern ?? ''}
                    onChange={e =>
                        onUpdateField(field._id, {
                            validation: {
                                pattern: e.target.value === '' ? undefined : e.target.value
                            }
                        })}
                />
            </Stack>
            <Stack>
                <Autocomplete
                    disabled={field.isDefault}

                    multiple
                    freeSolo
                    size='small'
                    options={[]}
                    value={field.validation?.allowedValues ?? []}
                    onChange={(_, newValue) =>
                        onUpdateField(field._id, {
                            validation: {
                                allowedValues: newValue.length === 0 ? undefined : newValue
                            }
                        })}
                    renderTags={(value: string[], getTagProps) =>
                        value.map((option: string, index: number) => {
                            const tagProps = getTagProps({ index })

                            return (
                                <Chip
                                    key={`${option}-${index}`}
                                    variant='outlined'
                                    label={option}
                                    {...tagProps}
                                />
                            )
                        })}
                    renderInput={params => (
                        <TextField
                            {...params}
                            label='Allowed Values'
                            placeholder='Type and press Enter'
                        />
                    )}
                />
            </Stack>
            <Stack>
                <PaduConfig
                    field={field}
                    onUpdateField={onUpdateField}
                />
            </Stack>
        </Stack>
    )
}

export default StringFieldConfig
